import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormItemBase } from '../../models/form-item-base';
import { FormItemControlService } from '../../services/form-item-control.service';
import { AppInfoService } from 'src/app/shared/services';
import { formLayoutEnum } from 'src/app/services/formLayoutEnum';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-form-item',
  templateUrl: './dynamic-form-item.component.html',
  styleUrls: [ './dynamic-form-item.component.scss' ]
})
export class DynamicFormItemComponent {
  @Input() formItem: FormItemBase<any>;
  @Input() form: FormGroup;
  selectedItems: any[];
  formCtrlService: FormItemControlService;
  appInfoService: AppInfoService;
  formLayout: formLayoutEnum;
  showTooltip: boolean;
  tooltipBody: SafeHtml;
  tooltipLinkURL: string;
  tooltipLinkText: string;
  tooltipHeader: string;
  tooltipImage: string;
  tooltipDlgWidth: number;
  tooltipDlgHeight: number;
  hasTooltipLink: boolean;
  hasTooltipImg: boolean;
  showConfirmActionDlg: boolean;
  pendingActionControl: any;
  invokeActionProc: any;
  showLoadDialog: boolean;
  showSaveDialog: boolean;
  saveFileName: string;

  constructor(private fcs: FormItemControlService,
              private ais: AppInfoService,
              private sanitizer: DomSanitizer) {
    this.formCtrlService = fcs;
    this.appInfoService = ais;
    this.showTooltip = false;
    this.showConfirmActionDlg = false;
    this.pendingActionControl = null;
    this.invokeActionProc = null;
    this.showLoadDialog = false;
    this.showSaveDialog = false;
  }


  get isValid() {
    let ret = false;

    if (this.form != null) {
      if (this.form.controls[this.formItem.key] != null) {
        ret = this.form.controls[this.formItem.key].valid;
      }
    }
    return ret;
  }

  get isCommentDefined() {
    let ret = false;

    if (this.formItem != null) {
      ret = (this.formItem.comment.length > 0);
    }

    return ret;
  }

  onListSelectionChanged(e) {
    console.log('onListSelectionChanged');
  }

  onValidateButtonClicked(e) {
    //this.validateFormItems();
  }

  onCopyButtonClicked(e) {
    const worksheet = this.formCtrlService.getCurrentWorksheet();
    const controlID = e.element.getAttribute('data-control-id');
    const formItem = this.formCtrlService.lookupFormItemFromDict(controlID);
    const control = this.formCtrlService.getWorksheetControl(controlID);
    this.pendingActionControl = control;

    if (formItem.bAlertUser) {
      this.invokeActionProc = this.invokeCopy;
      this.showConfirmActionDlg = true;
    } else {
      if (control != null && worksheet != null && formItem != null) {
        this.invokeCopy(control);
      }
    }

  }

  onNumberBoxContentReady(e) {
    //console.log('onNumberBoxContentReady');
  }

  onNumberBoxValueChanged(e) {
    console.log('onNumberBoxValueChanged');
    if (!this.formCtrlService.AllowUpdates && e.previousValue.toString() === e.value.toString()) {
      console.log('onNumberBoxValueChanged: AllowUpdates false and value unchanged, ignoring...');
      return;
    }

    const controlID = e.element.getAttribute('data-control-id');

    console.log('onNumberBoxValueChanged: controlID = ' + controlID);

    const control = this.formCtrlService.getWorksheetControl(controlID);

    if (!control) {
      return;
    }

    if (control.IsReadOnly) {
      return;
    }

    let newValue = '';
    if (e.value != null) {
      newValue = e.value.toString();
    }

    const postParams = {
      controlID,
      newValue,
      bLookupOption: false
    };

    this.formCtrlService.enqueueUserInput(postParams);
  }

  onCheckBoxValueChanged(e) {
    console.log('onCheckBoxValueChanged');

    const controlID = e.element.getAttribute('data-control-id');

    const control = this.formCtrlService.getWorksheetControl(controlID);
    if (control.IsReadOnly) {
      return;
    }

    let newValue = '';
    if (e.value != null) {
      newValue = e.value.toString();
    }

    if (!this.formCtrlService.bAllowUpdates) {
      this.appInfoService.getStatus(this.formCtrlService.token).subscribe({
        complete: () => {
          const postParams = {
            controlID,
            newValue,
            bLookupOption: false
          };

          this.formCtrlService.enqueueUserInput(postParams);

          this.formCtrlService.setFormLoadingObservable(false);
        }});
    } else {

      const postParams = {
        controlID,
        newValue,
        bLookupOption: false
      };

      this.formCtrlService.enqueueUserInput(postParams);
    }
  }

  onTextAreaValueChanged(e) {
    if (!this.formCtrlService.bAllowUpdates && e.previousValue === e.value) {
      console.log('onTextAreaValueChanged: AllowUpdates false and value unchanged, ignoring...');
      return;
    }

    const controlID = e.element.getAttribute('data-control-id');
    const control = this.formCtrlService.getWorksheetControl(controlID);
    if (control.IsReadOnly) {
      return;
    }

    let newValue = '';
    if (e.value != null)
    {
      newValue = e.value.toString();
    }

    const postParams = {
      controlID,
      newValue,
      bLookupOption: false
    };

    this.formCtrlService.enqueueUserInput(postParams);
  }

  onSelectBoxValueChanged(e) {
    if (!this.formCtrlService.bAllowUpdates && e.previousValue.toString() === e.value.toString()) {
      console.log('onSelectBoxValueChanged: AllowUpdates false and value unchanged, ignoring...');
      return;
    }

    const controlID = e.element.getAttribute('data-control-id');

    const control = this.formCtrlService.getWorksheetControl(controlID);
    if (control.IsReadOnly) {
      return;
    }

    let newValue = '';
    if (e.value != null) {
      newValue = e.value.toString();
    }

    const postParams = {
      controlID,
      newValue,
      bLookupOption: true
    };

    this.formCtrlService.enqueueUserInput(postParams);
  }

  invokeCopy(control) {
    const controlID = control.ID;
    const elts = document.getElementsByName(controlID) as NodeListOf<HTMLInputElement>;

    if (elts != null && elts.length === 1) {
      elts[0].focus();
      elts[0].setSelectionRange(0, 99999);

      navigator.clipboard.writeText(elts[0].value)
        .then(() => { console.log('Copied text: ' + elts[0].value); })
        .catch((error) => { console.log('Copy error: ' + error); } );

      elts[0].setSelectionRange(0, 0);
    }
  }

  invokeAction(control) {
    const controlID = control.ID;
    const formItem = this.formCtrlService.lookupFormItemFromDict(controlID);
    const worksheet = this.formCtrlService.getCurrentWorksheet();

    if (formItem != null && formItem.actionType === 'copypaneltext') {
      // Special button.  Copy all user input on the worksheet and place in clipboard
      let clipboardStr = '';

      worksheet.worksheetData.ControlList.forEach(e1 => {
        const currentItem = this.formCtrlService.lookupFormItemFromDict(e1.ID);

        if (currentItem != null) {
          if (e1.DataType != null && e1.DataType !== 'action' && currentItem.itemType === 'form') {
            if (currentItem.isVisible) {
              for (let i = 0; i < e1.Depth; i++) {
                clipboardStr += '    '; // indent for depth
              }

              if(currentItem.useAltText){
                clipboardStr += currentItem.altlabel;
              }
              else{
                clipboardStr += e1.Text;
              }

              if (!e1.Text.endsWith(':')) {
                clipboardStr += ':';
              }

              clipboardStr += ' ';

              if (currentItem.value != null) {
                clipboardStr += ' ' + currentItem.value;
              }

              clipboardStr += '\n';
            }
          }
        }
      });

      navigator.clipboard.writeText(clipboardStr);
    } 
    else if (formItem != null && formItem.actionType === 'saveworksheet'){

      formItem.alertMessage = "Please enter an identifier for the case:";
      this.saveFileName = "";
      this.showSaveDialog = true;

      
    }
    else if(formItem != null && formItem.actionType === 'loadworksheet'){
      var input = document.createElement('input');
      input.type = 'file';

      interface HTMLInputEvent extends Event {
        target: HTMLInputElement & EventTarget;
      }

      input.onchange = (e?: HTMLInputEvent) => { 

        var file = e.target.files[0]; 
     
        var reader = new FileReader();
        reader.readAsText(file,'UTF-8');
     
        reader.onload = readerEvent => {
           var content = reader.result; 
           //console.log( content );
           var loadMessage = "";
           try{
            var loadedCase = JSON.parse(content as string);
            worksheet.ForceReset = true;
            this.appInfoService.updateWorksheet(this.formCtrlService.token, worksheet).subscribe({
              next: (data: any[]) => {
                   console.log('updateWorksheet: next');
                   this.formCtrlService.AllowUpdates = false;
                   this.formCtrlService.updateCurrentWorksheet(data);
                   this.formCtrlService.setFormLoadingObservable(false);
        
                   // Refresh the expiration date of the token
                  //this.forceTokenRefresh();
        
                  worksheet.ForceReset = false;
                  
                  
                  //Set the worksheet values to those of the loaded worksheet. Make note of any discrepancies
                  loadMessage = this.formCtrlService.loadWorksheetValues(loadedCase);
                  formItem.alertMessage = loadMessage;
                  this.showLoadDialog = true;
             },
             error: (data: any) => {
               // tslint:disable-next-line: max-line-length
               if (data != null)
               {
                 if (data.status == 401) {
                  this.formCtrlService.setFormErrorObservable(true, 'Logged off due to inactivity');
                  this.formCtrlService.logoff();
                 } else {
                  this.formCtrlService.setFormErrorObservable(true, 'Failed to update the worksheet.  Error: ' + data.status + ', ' + data.statusText);
                  this.formCtrlService.forceTokenRefresh();
                 }
               } else {
                this.formCtrlService.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
                this.formCtrlService.forceTokenRefresh();
               }
               this.formCtrlService.setFormLoadingObservable(false);
               loadMessage = "Load Failed";
               formItem.alertMessage = loadMessage;
               this.showLoadDialog = true;
             }
           });
            /*
            this.formCtrlService.loadWorksheetValues(loadedCase).subscribe({
              next: (data: any) => {
                formItem.alertMessage = data;
                this.showLoadDialog = true;
              },
              error: (data: any) => {
                formItem.alertMessage = "Load Failed";
                this.showLoadDialog = true;
              }
            });*/
          }
          catch(err){
            loadMessage = "Load Failed";
            formItem.alertMessage = loadMessage;
            this.showLoadDialog = true;
          }
           
           
           
        }
     
     }
 
      input.click();

    }
    else {
      // User defined, post it
      if (controlID != null) {
        this.formCtrlService.updateFormItems(controlID, '', true, true);
      }
    }
  }

  onSaveDialogOKClicked(e) {
    this.showSaveDialog = false;
    const worksheet = this.formCtrlService.getCurrentWorksheet();
    var date = new Date().toLocaleString();
      //var jsonBlob = new Blob([JSON.stringify(worksheet)], { type: 'application/javascript;charset=utf-8' });
      console.log(worksheet);
      
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(worksheet)));
      element.setAttribute('download', this.saveFileName + "_" + date + ".allo");
    
      element.style.display = 'none';
      document.body.appendChild(element);
    
      element.click();
    
      document.body.removeChild(element);
  }

  onSaveDialogCancelClicked(e) {
    this.showSaveDialog = false;
  }

  onActionButtonClicked(e) {
    const controlID = e.element.getAttribute('data-control-id');

    const control = this.formCtrlService.getWorksheetControl(controlID);
    this.pendingActionControl = control;
    const worksheet = this.formCtrlService.getCurrentWorksheet();

    const formItem = this.formCtrlService.lookupFormItemFromDict(controlID);
    const thisService = this;

    if (formItem.bAlertUser) {
      this.invokeActionProc = this.invokeAction;
      this.showConfirmActionDlg = true;
    } else {
      if (control != null && worksheet != null && formItem != null) {
        this.invokeAction(control);
      }
    }
  }

  onAlertDialogOKClicked(e) {
    if (this.pendingActionControl != null && this.invokeActionProc != null) {
      this.invokeActionProc(this.pendingActionControl);
    }
    this.showConfirmActionDlg = false;
  }

  onAlertDialogCancelClicked(e) {
    this.showConfirmActionDlg = false;
  }

  onLoadDialogOKClicked(e) {
    
    this.showLoadDialog = false;
  }

  onTooltipClicked(e) {
    const controlID = e.element.getAttribute('data-control-id');

    const worksheet = this.formCtrlService.getCurrentWorksheet();

    if (controlID != null) {
      this.appInfoService.getTooltip(this.formCtrlService.token, worksheet, controlID).subscribe({
        next: (data: any) => {
            this.tooltipBody = this.sanitizer.bypassSecurityTrustHtml(data.Body);
            this.tooltipHeader = data.Header;
            this.tooltipLinkURL = data.LinkURL;
            this.tooltipLinkText = data.LinkText;
            this.tooltipImage =  'data:image/jpg;base64,' + data.Image;
            this.tooltipDlgWidth = data.DlgWidth;
            this.tooltipDlgHeight = data.DlgHeight;

            if (data.Image != null) {
              this.hasTooltipImg = data.Image.length > 0;
            }

            if (data.LinkURL != null) {
              this.hasTooltipLink = (data.LinkURL.length > 0) && (data.LinkText.length > 0);
            }

            this.showTooltip = true;
            this.formCtrlService.setFormErrorObservable(false, '');

            this.formCtrlService.forceTokenRefresh();
        },
        error: (data: any) => {
          // tslint:disable-next-line: max-line-length
          this.formCtrlService.setFormErrorObservable(true, 'Failed to retrieve the tooltip from the server.  Error: ' + data.status + ', ' + data.statusText);
        }
      });
    }
  }

}

